<template>
  <div class="order-card" @click.stop.prevent="toDetail">
    <div class="containerwrap">
      <div class="flexwrap" v-if="!hunbol">
        <div class="fl oneline">订单编号：{{ viewData["order_no"] }}</div>
        <div class="fr">
          {{ orderState[viewData["state"]] }}
        </div>
      </div>
      <div class="container">
        <div v-if="hunbol" class="zhline"></div>
        <div :class="[hunbol ? 'hun-box' : 'img-box']">
          <img
            v-if="viewData['image_urls']"
            v-lazy="viewData['image_urls'].single"
            alt="avatar box"
          />
        </div>
        <div
          class="detail-box"
          :class="{
            'hundetail-box': hunbol,
          }"
        >
          <div class="head">
            <div class="head-desc">{{ viewData["description"] }}</div>
            <span v-if="hunbol" class="order-state">{{
              orderState[viewData["state"]]
            }}</span>
          </div>
          <div v-if="hunbol" class="order-id">
            订单编号：
            <p>{{ viewData["order_no"] }}</p>
          </div>
          <div v-else class="order-id oiflexwrap">
            <div class="oidl">冲印版数：{{ viewData["quantity"] }}</div>
            <div class="oidr oneline">
              {{
                !isMerge
                  ? viewData["state"] === "waiting"
                    ? "应付："
                    : "实付："
                  : ""
              }}
              <span class="currency">¥</span>
              <span class="price-big">{{ showPrice.beforeDot }}</span>
              <span class="price-small">.{{ showPrice.afterDot }}</span>
            </div>
          </div>
          <div class="tail-row">
            <template v-if="!isMerge && hunbol">
              {{ viewData["state"] === "waiting" ? "应付：" : "实付：" }}
              <span class="currency">¥</span>
              <span class="price-big">{{ showPrice.beforeDot }}</span>
              <span class="price-small">.{{ showPrice.afterDot }}</span>
            </template>
          </div>
          <template v-if="!isMerge && !hunbol">
            <!-- 待付款的订单显示操作按钮 -->
            <footer v-if="viewData['state'] === 'waiting'">
              <button @click.stop.prevent="btnClick('modify')">修改地址</button>
              <button @click.stop.prevent="btnClick('cancel')">取消订单</button>
              <button @click.stop.prevent="btnClick('pay')" v-if="!hidePay">
                去支付
              </button>
            </footer>
            <footer
              v-if="
                viewData['state'] === 'completed' ||
                viewData['state'] === 'refunded'
              "
            >
              <button @click.stop.prevent="btnClick('delete')">删除订单</button>
            </footer>
          </template>
        </div>
      </div>
    </div>
    <template v-if="!hunbol && viewData.append_orders.length > 0">
      <div class="addtitle">加印照片</div>
      <div class="addwrap">
        <div
          class="addlist"
          v-for="item in viewData.append_orders"
          :key="item.id"
        >
          <div class="addlistl oneline">
            {{ item.spec_name }}（{{ item.color }}）
          </div>
          <div class="addlistr">+{{ item.quantity }}（版）</div>
        </div>
      </div>
    </template>
    <template v-if="!isMerge && hunbol">
      <!-- 待付款的订单显示操作按钮 -->
      <footer v-if="viewData['state'] === 'waiting'">
        <button @click.stop.prevent="btnClick('modify')">修改地址</button>
        <button @click.stop.prevent="btnClick('cancel')">取消订单</button>
        <button @click.stop.prevent="btnClick('pay')" v-if="!hidePay">
          去支付
        </button>
      </footer>
      <footer
        v-if="
          viewData['state'] === 'completed' || viewData['state'] === 'refunded'
        "
      >
        <button @click.stop.prevent="btnClick('delete')">删除订单</button>
      </footer>
    </template>
  </div>
</template>

<script>
import { ORDER_STATE } from "../utils/const";

export default {
  name: "OrderCard",

  props: {
    viewData: {
      required: true,
      type: Object,
    },

    isMerge: {
      type: Boolean,
      default: false,
    },

    isMixtoDetail: {
      type: Boolean,
      default: false,
    },

    hidePay: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      orderState: ORDER_STATE,
    };
  },

  methods: {
    toDetail() {
      if (this.isMixtoDetail) {
        console.log("replace::::");
        this.$router.replace({
          name: "orderDetail",
          params: {
            order_id: this.viewData.id,
          },
          query: {
            isMerge: this.isMerge ? "1" : "",
          },
        });
      } else {
        this.$router.push({
          name: "orderDetail",
          params: {
            order_id: this.viewData.id,
          },
          query: {
            isMerge: this.isMerge ? "1" : "",
          },
        });
      }
    },

    btnClick(action) {
      this.$emit("orderCardAction", action);
    },
  },

  computed: {
    hunbol() {
      return (
        this.viewData.extra &&
        (this.viewData.extra.type === "marriage" ||
          this.viewData.extra.phototype === "marriage")
      );
    },
    showPrice() {
      let price = Number(
        this.viewData[this.isMerge ? "price_total" : "actual_amount_paid"]
      );
      let dot = price % 100;
      return {
        beforeDot: parseInt(price / 100),
        afterDot: dot >= 10 ? dot : `0${dot}`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.oneline {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.order-card {
  width: 100%;
  .flexwrap {
    display: flex;
    justify-content: space-between;
    font-size: 0.12rem;
    color: rgba(54, 54, 54, 0.5);
    align-items: center;
    margin-bottom: 0.16rem;
    .fr {
      font-size: 0.14rem;
      color: #394be5;
      font-weight: bold;
      flex-shrink: 0;
      margin-left: 0.05rem;
    }
    .fl {
      flex-grow: 1;
    }
  }
  .container {
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: space-between;

    .zhline {
      height: 1px;
      width: 100%;
      background-color: rgba(151, 151, 151, 0.3);
      position: absolute;
      left: 0;
      bottom: 28px;
    }
  }

  .img-box {
    width: 0.52rem;
    height: 0.74rem;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .hun-box {
    width: 82px;
    height: 54px;
    flex-shrink: 0;
    margin-right: 8px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .detail-box {
    width: calc(100% - 0.6rem);
    position: relative;
    padding-bottom: 0.18rem;

    .head {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      font-weight: bold;

      .head-desc {
        font-size: 0.16rem;
        color: rgba(54, 54, 54, 1);
      }

      .order-state {
        flex-shrink: 0;
        font-size: 0.14rem;
        margin-left: 0.04rem;
        color: rgba(57, 75, 229, 1);
      }
    }

    .order-id {
      font-size: 0.12rem;
      color: rgba(54, 54, 54, 0.5);
      margin-top: 0.08rem;
    }

    .tail-row {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 0.12rem;

      .tail {
        font-size: 0.14rem;
      }

      .price-big {
        font-size: 0.18rem;
      }
    }
  }
  .hundetail-box {
    padding-bottom: 43px;
  }
  footer {
    margin-top: 0.18rem;
    display: flex;
    align-self: center;
    justify-content: flex-end;

    button {
      border: 1px solid #4455e4;
      border-radius: 0.02rem;
      padding: 0.05rem 0.14rem;
      color: #4455e4;
      font-size: 0.12rem;
      opacity: 0.6;

      & + button {
        margin-left: 0.12rem;
        opacity: 1;
      }
    }
  }
}
.addtitle {
  color: rgba(54, 54, 54, 0.5);
  font-size: 0.12rem;
  margin: 0.16rem 0 0.08rem;
}
.addwrap {
  box-sizing: border-box;
  background-color: #f8fafe;
  border-radius: 0.02rem;
  padding: 0.16rem;
}
.addlist {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.14rem;
  font-size: 0.12rem;
}
.addlistl {
  flex-grow: 1;
  margin-right: 0.1rem;
  color: #363636;
}
.addlistr {
  flex-shrink: 0;
  white-space: nowrap;
  color: rgba(54, 54, 54, 0.5);
}
.addlist:first-child {
  margin-top: 0;
}
</style>